"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderDots = void 0;
var _react_image_sliderModule = _interopRequireDefault(require("@albelli/arc-3/lib/react_image_slider.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SliderDots = _ref => {
  let {
    images,
    currentSlide,
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_react_image_sliderModule.default["arc3-react-image-slider__main-wrapper__dots"])
  }, images.map((_, idx) => /*#__PURE__*/_react.default.createElement("div", {
    key: idx,
    onClick: () => onClick(idx),
    className: (0, _classnames.default)(currentSlide === idx ? _react_image_sliderModule.default["--active"] : "")
  })));
};
exports.SliderDots = SliderDots;
SliderDots.propTypes = {
  /** Array of images */
  images: _propTypes.PropTypes.array,
  /** image idx */
  currentSlide: _propTypes.PropTypes.number,
  /** onClick: (idx: number) => void */
  onClick: _propTypes.PropTypes.func
};